/**
 * ステータス: 回答募集中
 */
export const CLIENT_HOTLINE_STATUS_OPEN = {
    label: '回答募集中',
    value: 'OPEN',
};
/**
 * ステータス: コンサル選定中
 */
export const CLIENT_HOTLINE_STATUS_SCHEDULING = {
    label: 'コンサル選定中',
    value: 'SCHEDULING',
};
/**
 * ステータス: 相談完了
 */
export const CLIENT_HOTLINE_STATUS_COMPLETED = {
    label: '相談完了',
    value: 'COMPLETED',
};
/**
 * ステータス: 募集終了
 */
export const CLIENT_HOTLINE_STATUS_CLOSED = {
    label: '募集終了',
    value: 'CLOSED',
};
/**
 * 匿名ホットライン開示ステータス一覧
 */
export const CLIENT_HOTLINE_STATUSES = [
    CLIENT_HOTLINE_STATUS_OPEN,
    CLIENT_HOTLINE_STATUS_SCHEDULING,
    CLIENT_HOTLINE_STATUS_COMPLETED,
    CLIENT_HOTLINE_STATUS_CLOSED,
];
